import React, { FC } from 'react';
import { CustomButton, CustomModal } from 'components';
import { GreenTickAnimatedIcon } from 'assets/icons';

interface PayRuleCreationSuccessModalProps {
  open: boolean;
  onClose: () => void;
  isEdit: boolean;
}

const PayRuleCreationSuccessModal: FC<PayRuleCreationSuccessModalProps> = ({ open, onClose, isEdit }) => {
  return (
    <CustomModal
      open={open}
      closeModal={onClose}
      backgroundColor="bg-white"
      className="h-[344px] w-[375px] md:w-[375px]"
      borderRadius="rounded">
      <div className="flex w-full flex-col items-center py-9 px-[30px] text-center">
        <GreenTickAnimatedIcon className="my-5 text-success" />
        <div className="mb-4 text-17px font-semibold text-headingGray">
          {isEdit ? 'Pay rule updated' : 'New pay rule created'}
        </div>
        <div className="mb-8 text-sbase font-semibold text-primaryText">
          This rule will only apply to new jobs and will not affect previously created ones.
        </div>

        <CustomButton
          id="success-modal-ok-btn"
          onClick={onClose}
          className="mt-4 h-10 w-full rounded bg-primaryBtn text-white">
          Okay
        </CustomButton>
      </div>
    </CustomModal>
  );
};

export default PayRuleCreationSuccessModal;
